import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {
  1: {
    unit: 'Unit 10',
    id: 'WB4-V2-U10-P69-E1',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page69/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page69/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page69/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page69/E1/3.jpg', input: true, answer: "Is she singing?" },
        { url: 'img/FriendsPlus/Page69/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page69/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page69/E1/6.jpg', input: true, answer: "No, she isn't." },
        { url: 'img/FriendsPlus/Page69/E1/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page69/E1/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page69/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page69/E1/10.jpg', input: true, answer: "Is he eating?" },
        { url: 'img/FriendsPlus/Page69/E1/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page69/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page69/E1/13.jpg', input: true, answer: "No, he isn't." },
        { url: 'img/FriendsPlus/Page69/E1/14.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page69/E1/15.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page69/E1/16.jpg' },
        { url: 'img/FriendsPlus/Page69/E1/17.jpg', input: true, answer: "Is she sleeping?" },
        { url: 'img/FriendsPlus/Page69/E1/18.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page69/E1/19.jpg' },
        { url: 'img/FriendsPlus/Page69/E1/20.jpg', input: true, answer: "Yes, she is." },
        { url: 'img/FriendsPlus/Page69/E1/21.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page69/E1/22.jpg' },
      ],
      [
        // Column11
        { url: 'img/FriendsPlus/Page69/E1/23.jpg' },
        { url: 'img/FriendsPlus/Page69/E1/24.jpg', input: true, answer: "Are they eating?" },
        { url: 'img/FriendsPlus/Page69/E1/25.jpg' },
      ],
      [
        // Column12
        { url: 'img/FriendsPlus/Page69/E1/26.jpg' },
        { url: 'img/FriendsPlus/Page69/E1/27.jpg', input: true, answer: "No, they aren't." },
        { url: 'img/FriendsPlus/Page69/E1/28.jpg' },
      ],
      [
        // Column13
        { url: 'img/FriendsPlus/Page69/E1/29.jpg' },
      ],


    ]
  },
  2: {
    unit: 'Unit 10',
    id: 'WB4-V2-U10-P69-E2',
    audio: '',
    video: '',
    component: UI,
    titleImage: '',
    recorder: true,
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page69/E2/1.jpg' },
      ]
    ]
  },



}
export default json;